import { createFileRoute } from '@tanstack/react-router'
import { MessageTemplatesSettingsPage } from '@/features/settings/components/message-templates-settings-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/settings/message-templates',
)({
  component: MessageTemplatesSettingsPage,
  beforeLoad: async () => {
    return {
      title: 'Message templates',
      headerTitleKey: 'header.messageTemplates.title',
      headerDescriptionKey: 'header.messageTemplates.description',
    }
  },
})
